module.exports = __webpack_public_path__ + "static/media/plumber.7ec41439.jpg";